/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CompatibilityModule, UNIQUE_SELECTION_DISPATCHER_PROVIDER} from '@angular/material/core';
import {A11yModule} from '@angular/cdk/a11y';
import {CdkAccordion, MdAccordion} from './accordion';
import {MdExpansionPanel, MdExpansionPanelActionRow} from './expansion-panel';
import {
  MdExpansionPanelDescription,
  MdExpansionPanelHeader,
  MdExpansionPanelTitle,
} from './expansion-panel-header';
export class MdExpansionModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CompatibilityModule, CommonModule, A11yModule],
  exports: [
    CdkAccordion,
    MdAccordion,
    MdExpansionPanel,
    MdExpansionPanelActionRow,
    MdExpansionPanelHeader,
    MdExpansionPanelTitle,
    MdExpansionPanelDescription
  ],
  declarations: [
    CdkAccordion,
    MdAccordion,
    MdExpansionPanel,
    MdExpansionPanelActionRow,
    MdExpansionPanelHeader,
    MdExpansionPanelTitle,
    MdExpansionPanelDescription
  ],
  providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdExpansionModule_tsickle_Closure_declarations() {
/** @type {?} */
MdExpansionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdExpansionModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
